/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { edit_radius_pembanding } from "../../App/actions/propertiesActions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

class EditRadiusPembanding extends Component {
  state = {
    radius_pembanding: 500, //meter
  };

  componentDidMount() {
    const { layer_id, geo_layer_list } = this.props.layer;
    const layer = geo_layer_list.find(
      (item) => item.geo_layer._id === layer_id
    )?.geo_layer;
    const radius_pembanding = layer?.radius_pembanding;
    if (radius_pembanding) {
      this.setState({ radius_pembanding });
    }
  }

  on_change = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  };

  on_submit = () => {
    const { layer_id } = this.props.layer;
    const { radius_pembanding } = this.state;
    const body = {
      geo_layer_id: layer_id,
      radius_pembanding,
    };

    this.props.edit_radius_pembanding(body);
    this.props.toggle_edit_radius_pembanding();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state

    const { radius_pembanding } = this.state;
    return (
      <div>
        <h1 className="text_header">
          {
            dict?.[
              "Edit comparison data radius (Data Pembanding FORM MAPID)"
            ]?.[language]
          }
        </h1>
        <p className="text_inferior">
          {
            dict?.[
              "Edit the radius to limit the comparative data that will be displayed on comparative data submission by the surveyor."
            ]?.[language]
          }
        </p>
        <br />
        <br />
        <p className="text_inferior">
          {dict?.["Comparison data radius in meters"]?.[language]}
        </p>
        <input
          id="radius_pembanding"
          name="radius_pembanding"
          value={radius_pembanding}
          onChange={this.on_change}
        />
        <br />
        <div className="button background_black" onClick={this.on_submit}>
          {dict?.["Save"]?.[language]}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  auth: state.auth,
});

export default connect(mapStateToProps, { edit_radius_pembanding })(
  EditRadiusPembanding
);
